<template>
   <div class="asset-wrapper" :class="{active: active, hidden_zone: isHidden, move: isMoving, locked: locked}" :style="getZIndex">
      <div class="zone-label" :style="getZoneLabelStyle">Zone {{zone.id/1000}} {{zone.name}}</div>
     
      <div id="image_asset" class="asset-shadow" :class="{video: zone.type == 2 || (zone.type instanceof Array && zone.type.includes(2)), move: isMoving, feed: zone.val != '' && zone.val instanceof Array && zone.val.length > 1}" :style="style">
  
         <!-- First, if there's an asset override, just display that -->
         <img class="asset-override" v-if=" zone.val != '' && zone.asset_override != '' && zone.asset_override != undefined" v-bind:src="this.GALLERY_HOST + '/' + zone.asset_override">

         <!-- For a feed -->
         <img ref="image" v-else-if="zone.val != '' && zone.val instanceof Array && zone.val.length > 0" :id="'zone_image-' + zone.id" class="zone-image feed" v-bind:src="this.GALLERY_HOST + '/' + zone.val[0]">
         <!-- If we're an image, display the image itself -->
         <img ref="image" v-else-if="zone.val != '' && zone.val_type == 1" :id="'zone_image-' + zone.id" class="zone-image" :style="imageStyle" v-bind:src="this.GALLERY_HOST + '/' + zone.val">

         <!-- Otherwise, if there's a thumbnail, display that -->
         <img class="thumb-image" v-else-if="zone.thumb != '' && zone.thumb != undefined && !(zone.thumb instanceof Array)" v-bind:src="this.GALLERY_HOST + '/' + zone.thumb">
         <img class="thumb-image" v-else-if="zone.thumb != '' && zone.thumb != undefined" v-bind:src="this.GALLERY_HOST + '/' + zone.thumb[0]">

         <!-- If nothing is set just display an empty div -->
         <div class="empty-image" v-else></div>

         <div v-if="isMoving" class="image-overlay" :style="overlayStyle">
            <div class="vertical-line"></div>
            <div class="horizontal-line"></div>
         </div>

         <div v-if="!zone.required && zone.val != '' && !locked" class="close-btn-asset" @click.stop="$emit('removeAsset')">
            X
         </div>
      </div>
      
   </div>
</template>

<script>
import Zone from './Zone';
import { mapActions, mapState } from 'vuex';

export default {
   extends: Zone,

   data() {
      return {
         leftPos: 0,
         topPos: 0,
      }
   },

   created() {
       if (this.val != '') {
         let self = this;
         let identifier = '#zone_image-' + this.zone.id;
         $(function() {
            "use strict";
            $(identifier).draggable({
               // snap: "#image_asset",
               // grid: [10, 10],
               stop: function() {
                  self.$parent.$emit('ImageDrag');
                  self.zone.assetY = this.offsetTop;
                  self.zone.assetX = this.offsetLeft;
               }
            });

            $(identifier).draggable('disable');
         });
      }
   },

   computed: {
      ...mapState([
         'activeZone',
      ]),

      isActiveZone() {
         return this.activeZone.id == this.zone.id;
      },

      isAssigningAsset() {
         return this.zone.isAssigningAsset;
      },

      imageStyle() {
         let transform = 'rotate(' + this.zone.rotation + 'deg)';
         let assetWidth = 'auto';
         if (this.zone.assetW > 0) {
            assetWidth = this.zone.assetW * Math.abs(this.zone.scaleX) + 'px';
         }

         if (this.zone.scaleX < 0) {
            transform += ' scaleX(-1)';
         }
         if (this.zone.scaleY < 0) {
            transform += ' scaleY(-1)';
         }

         let top = this.zone.assetY;
         let left = this.zone.assetX;

         if (this.zone.animation) {
            if (this.zone.animation[this.currScene].end.scale) {
               transform += ' scale(.38)';
               top *= parseFloat(this.zone.animation[this.currScene].end.scale);
               left *= parseFloat(this.zone.animation[this.currScene].end.scale);
            }
         }

         return 'width: ' + assetWidth + '; transform: ' + transform + ';' + 'top: ' + top + 'px; left: ' + left + 'px;';
      },

      isMoving() {
         return this.moveImageZoneId == this.zone.id;
      },

      overlayStyle() {
         // let transform = 'rotate(' + this.zone.rotation + 'deg)';
         let width = this.zone.width;
         let height = this.zone.height;
         if (this.zone.animation) {
            if (this.zone.animation[this.currScene].end.width) {
               width = this.zone.animation[this.currScene].end.width;
            }
            if (this.zone.animation[this.currScene].end.height) {
               height = this.zone.animation[this.currScene].end.height;
            }
         }
         

         // if (this.zone.scaleX < 0) {
         //    transform += ' scaleX(-1)';
         // }
         // if (this.zone.scaleY < 0) {
         //    transform += ' scaleY(-1)';
         // }

         return 'width: ' + width + 'px; height: ' + height + 'px;';
      }
   },

   watch: {
      'zone.val': function(newVal, oldVal) {
         if (this.zone.val != '') {
            let self = this;
            let identifier = '#zone_image-' + this.zone.id;
             $(function() {
               "use strict";
               $(identifier).draggable({
                  // snap: "#image_asset",
                  // grid: [10, 10],
                  stop: function() {
                     self.$parent.$emit('ImageDrag');
                     self.zone.assetY = this.offsetTop;
                     self.zone.assetX = this.offsetLeft;
                  }
               });
               $(identifier).draggable('disable');
            });
         }
      },

      'zone.assigningAsset': function(newVal, oldVal) {
         console.log('assigning');
      },

      /*
       * On move, make the image draggable
       */
      moveImageZoneId() { 
         if (this.isMoving) {
            if (this.val != '') {
               let self = this;
               let identifier = '#zone_image-' + this.zone.id;
                  $(function() {
                  "use strict";
                  $(identifier).draggable('enable');
               });
            }
         } else { //turn dragable off
            let self = this;
            let identifier = '#zone_image-' + this.zone.id;
               $(function() {
               "use strict";
               $(identifier).draggable('disable');
            });
         }
      }
   }
}
</script>

<style lang="scss">
.asset-wrapper.move {
   img {
      cursor: move;
   }
}
.asset-wrapper.locked {
   .zone-label {
      display: none;
   }
}
#image_asset {
   position: absolute;

   overflow: hidden;

   .asset-override {
      width: 100%;
      height: 100%;
   }

   .zone-image {
      max-width: none;
      max-height: none;

      // &.feed {
      //    width: 100%;
      //    height: 100%;
      // }
   }

   &.feed {
      display: flex;
      justify-content: center;
   }

   &.video {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
         max-width: 100%;
         max-height: 100%;
      }
   }

   &.move {
      overflow: visible;
   }

   .image-overlay {
      position: absolute;
      pointer-events: none;
      top: -1px; //to overlay the zone border
      left: -1px;
      z-index: 1001;
      border: 2px solid $bard-gold;
      box-shadow: 0 0 0 8000px #000000a6;
      background-image: url('./../../../assets/img/crop/grid-bg.svg');

      .vertical-line {
         border:none;
         border-right: 1px dashed #f00;
         position: absolute;
         width: 0px;
         height: 100%;
         left: 50%;
      }

      .horizontal-line {
         border:none;
         border-bottom: 1px dashed #f00;
         position: absolute;
         height: 0px;
         width: 100%;
         top: 50%;
      }
   }
}

.close-btn-asset {
   position: absolute;
   top: 6px;
   right:4px;
   font-size: 32px !important;
   padding: 2px 18px !important;
   background: $error-red;
   border-radius: 30px;
   color: white;

   &:hover {
      cursor: pointer;
   }
}
</style>